import { render, staticRenderFns } from "./OverviewTab.vue?vue&type=template&id=20532a4a&scoped=true"
import script from "./OverviewTab.vue?vue&type=script&lang=js"
export * from "./OverviewTab.vue?vue&type=script&lang=js"
import style0 from "./OverviewTab.vue?vue&type=style&index=0&id=20532a4a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20532a4a",
  null
  
)

export default component.exports